export class ExtraParameter {
    id: string;
    name: string;
    value:string;
    description:string;
  }


// WEBPACK FOOTER //
// ./src/app/classes/extraParameter.ts